import React, { useState, useEffect, useCallback } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import axios from 'axios';
import constClass from '../../Constants/Constants';
import moment from 'moment';
import TrainBookingList from "./TrainBookingList";
import { Link, useHistory } from 'react-router-dom';
import { generatePath } from 'react-router';

const TrainBookingListTab = (props) => {
  const history = useHistory();
  const { condition, conditionActions } = props;
  const [bookData, setBookData] = useState([]);
  const statusIndex = (status) => {
    if (status === constClass.STATUS_NFIN) {
      return 0;
    } else if (JSON.stringify(status) === JSON.stringify([constClass.STATUS.FIN])) {
      return 1;
    } else if (status === constClass.STATUS_CCL) {
      return 2;
    } else {
      return 0;
    }
  };
  const [calendarList, setCalendarList] = useState([]);
  const [ticketList, setTicketList] = useState([]);
  const [index, setIndex] = useState(statusIndex(condition.status));

  const handleTabSelect = (idx, lastIndex, e) => {
    setIndex(idx);
    conditionActions.setStatus(idx === 2 ? constClass.STATUS_CCL : idx === 1 ? [constClass.STATUS.FIN] : constClass.STATUS_NFIN)
  }

  const refreshMaster = useCallback(async () => {
    if (!condition.bookDate) {
      return;
    }
    if (!condition.initFlag) {
      setIndex(statusIndex(condition.status));
      conditionActions.init();
      return;
    }
    //トークンを取得
    const jwt = localStorage.getItem('jwt');
    const params = {
      site_id: props.siteId,
      book_start: condition.book_start,
      book_end: condition.book_end,
    }
    var reg_params = {};
    reg_params = {
      "operator": "and",
      "where": [
        { "site_id": props.siteId },
        { "book_date": moment(condition.bookDate, "YYYY/MM/DD").format("YYYY-MM-DD") }
      ]
    }
    var param = {};
    param = {
      "operator": "and",
      "where": [
        { "site_id": props.siteId }
      ]
    }
    const data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/train_booking/search/`, reg_params, { headers: { Authorization: `Bearer ${jwt}` } })).data;
    const calendarPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/train_calendar/listalldate/`, params, { headers: { Authorization: `Bearer ${jwt}` } });
    const ticketPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket/search`, param, { headers: { Authorization: `Bearer ${jwt}` } });
    const calendar = (await calendarPromise).data;
    const ticket = (await ticketPromise).data;
    if (calendar.length > 0 && !condition.bookDate && calendar.findIndex(x => moment(x.book_date).format('YYYYMMDD') === moment().format('YYYYMMDD')) >= 0) {
      conditionActions.setBookDate(moment(calendar.find(x => moment(x.book_date).format('YYYYMMDD') === moment().format('YYYYMMDD')).book_date).format('YYYY/MM/DD'));
    }
    setCalendarList(calendar);
    setTicketList(ticket);
    setBookData(data);

  }, [props.siteId, condition.initFlag, condition.status, condition.book_start, condition.book_end, condition.bookDate, conditionActions]);
  
  useEffect(() => {
    if (!condition.bookDate) {
      const today = moment().format('YYYY/MM/DD');
      conditionActions.setBookDate(today);
    }
  }, [props.siteId, condition.bookDate, condition.initFlag, condition.status, condition.book_start, condition.book_end, conditionActions]);
  
  useEffect(() => {
    refreshMaster();
  }, [refreshMaster]);

  const handleTicket = (e) => {
    const target = e.target;
    conditionActions.setTicket(target.value);
  }

  const changeBookDate = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    conditionActions.setBookDate(value);
  }

  const handleResetButtonClick = () => {
    conditionActions.logout();
  }

  const renderCancelButton = () => {
    const handleCancelClick = () => {
      // 利用日付とチケットの選択状態を確認
      if (!condition.bookDate || condition.ticket_id === "") {
        window.alert("利用日付とチケットを選択してください。");
      } else {
        const path = generatePath(
          `${props.match.path}totalcancel/${moment(condition.bookDate.replace(/\//g, '-')).format('YYYYMMDD')}/${condition.ticket_id}`,
          { siteId: props.match.params.siteId }
        );
        history.push(path);
      }
    };

    return (
      <Link to="#" onClick={handleCancelClick}>
        <button type="button"
          className={`btn btn-danger mx-1`}>
          一括キャンセル
        </button>
      </Link>
    );
  }


  const renderHeader = () => {
    return (
      <div className="mx-0">
        <div className="row mb-2">
          <div className="col-2 text-center align-self-center mb-4">
            <span>利用日付</span>
          </div>
          <div className="col-2 text-center align-self-center mb-4">
            <select className="custom-select w-100 text-center border-textbox text-primary"
              value={condition.bookDate}
              id="bookDate" name="bookDate" onChange={changeBookDate}>
              <option value="" >- 選択 -</option>
              {calendarList.map((item, idx) =>
                <option key={idx} value={moment(item.book_date).format('YYYY/MM/DD')}>{moment(item.book_date).format('YYYY/MM/DD')}({moment(item.book_date).format('dd')})</option>
              )}
            </select>
          </div>
          <div className="col-2 text-center align-self-center mb-4">
            <span>チケット</span>
          </div>
          <div className="col-2 text-center align-self-center mb-4">
            <select className="custom-select w-100" aria-label="チケット" value={condition.ticket_id} onChange={handleTicket}>
              <option value="">選択してください</option>
              {ticketList.map((item) =>
                <option key={item.ticket_id} value={item.ticket_id}>{item.ticket_name}</option>
              )}
            </select>
          </div>
          <div className="col-2"></div>
          <div className="col-2 text-center flex-column align-self-center">
            <div className="p-1">
              <button type="button"
                className={`btn btn-secondary mx-1 mb-3`}
                onClick={() => handleResetButtonClick()}>
                リセット
              </button>
            </div>
            <div className="p-1">
              {renderCancelButton()}
            </div>
          </div>
          {condition.bookDate && condition.ticket_id ?
            <div className="col-4 text-left mb-2"><font size="4">
              予約数{bookData.filter(item => moment(item.book_date).format("YYYY/MM/DD") === condition.bookDate && condition.ticket_id.includes(item.ticket_id) && item.status !== 'CCL' && item.status !== 'UPAY' && item.status !== 'CUPAY').reduce((total, booking) => total + booking.count, 0)}名/{ticketList.filter(item => condition.ticket_id.includes(item.ticket_id)).length > 0 ? ticketList.filter(item => condition.ticket_id.includes(item.ticket_id))[0].booking_limit : 0}名
            </font></div>
            : ""}
        </div>
      </div>
    )
  }

  return (
    <div className="container">
      {renderHeader()}
      <Tabs onSelect={handleTabSelect}>
        <div className="d-flex">
          <TabList className="nav nav-pills mb-2 w-75">
            <Tab className="nav-item"><button className={`nav-link ${index === 0 ? 'active' : ''}`}>未乗車</button></Tab>
            <Tab className="nav-item"><button className={`nav-link ${index === 1 ? 'active' : ''}`} href="#">乗車済(完了)</button></Tab>
            <Tab className="nav-item"><button className={`nav-link ${index === 2 ? 'active' : ''}`} href="#">キャンセル</button></Tab>
          </TabList>
          <div></div>{/* 凡例 */}
        </div>
        <TabPanel>
          <TrainBookingList {...props} bookData={bookData} />
        </TabPanel>
        <TabPanel>
          <TrainBookingList statusIdx={index} {...props} bookData={bookData} />
        </TabPanel>
        <TabPanel>
          <TrainBookingList statusIdx={index} {...props} bookData={bookData} />
        </TabPanel>
      </Tabs>
    </div>
  )
}

export default TrainBookingListTab;